import Pages from "./Pages";


function App() {
  return (
    <div className="App">
      <Pages />
    </div>
  );
}

export default App;
